import { Button, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { ContainerLayout, ReadMoreLink } from '../../components';
import { ErrorText } from '../../components/ErrorText';
import { useSetOfferLabel, useE2eLabelTracking } from '../../hooks';
import { FormContext } from '../../utils/formContext';
import { trackIntroBannerAddLabelClick } from '../../utils/tracking';
import { AddLabelWithoutProfilingContainerVerboseContent } from './components';

/**
 * Контейнер, где для добавления лейбла не нужно проходить профилирование.
 * Содержимое (краткое или подробное) зависит от полученно типа.
 */
export const AddLabelWithoutProfilingContainer: React.FC = () => {
  const formContext = React.useContext(FormContext);
  const isMobile = useDeviceType() === 'phone';
  const onTrackAddLabelClick = useE2eLabelTracking(trackIntroBannerAddLabelClick);
  const { isLoading, isError, setOfferLabel } = useSetOfferLabel({
    showLabel: true,
    onSuccess: () => {
      onTrackAddLabelClick({});
      /* istanbul ignore next */
      formContext.onStepYes?.();
    },
  });

  return (
    <ContainerLayout
      title={
        isMobile
          ? 'Попробуйте усилить ваше объявление значком «Онлайн-сделка»'
          : 'Попробуйте усилить ваше объявление значком'
      }
      content={<AddLabelWithoutProfilingContainerVerboseContent />}
      actions={
        <>
          <Button loading={isLoading} color="fill_primary" onClick={setOfferLabel}>
            Добавить значок
          </Button>
          {!isMobile && <ReadMoreLink theme="not-filled" />}
          {isError && <ErrorText />}
        </>
      }
      isWithRightSideImage
      isWithRingLabelImage
      actionsGap={16}
    />
  );
};
